var _g, _circle, _path, _g2, _circle2, _path2, _g3, _circle3, _path3, _g4, _circle4, _path4, _g5, _circle5, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDish(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 623,
    height: 451,
    viewBox: "0 0 623 451",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_126_525)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 163.5,
    r: 17.5,
    fill: "#98BCD6"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 115,
    cy: 164,
    r: 25,
    fill: "#98BCD6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121.288 151.238C118.677 149.883 116.303 150.522 114.643 151.428C112.99 152.33 111.135 152.827 109.252 152.872C107.362 152.918 104.987 153.551 103.403 156.031C100.402 160.728 105.339 166.361 106.601 167.221C107.863 168.081 108.294 169.563 109.792 172.423C111.291 175.283 112.934 177.937 114.556 177.037C116.178 176.136 116.078 173.9 115.756 170.958C115.734 170.756 115.716 170.565 115.702 170.385C115.609 169.151 117.278 168.704 117.813 169.819C117.892 169.982 117.972 170.156 118.054 170.342C119.245 173.051 120.277 175.038 122.132 175.007C123.988 174.976 124.083 171.855 123.951 168.629C123.819 165.403 123.45 163.904 124.113 162.529C124.777 161.153 126.236 153.806 121.288 151.238ZM109.527 155.903C109.574 156.272 109.313 156.611 108.944 156.66C108.812 156.679 105.894 157.125 105.927 160.433C105.93 160.748 105.717 161.016 105.425 161.094C105.371 161.108 105.315 161.116 105.256 161.117C104.883 161.12 104.577 160.82 104.573 160.447C104.537 156.822 107.302 155.507 108.769 155.318C109.139 155.27 109.479 155.532 109.527 155.903Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_126_525)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 352.5,
    r: 17.5,
    fill: "#98BCD6"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 353,
    r: 25,
    fill: "#98BCD6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2879 340.238C46.6766 338.883 44.3029 339.522 42.6434 340.428C40.9901 341.33 39.1349 341.827 37.252 341.872C35.3619 341.918 32.9868 342.551 31.4029 345.031C28.4019 349.728 33.339 355.361 34.6011 356.221C35.8632 357.081 36.2935 358.563 37.792 361.423C39.2905 364.283 40.9336 366.937 42.556 366.037C44.1783 365.136 44.0784 362.9 43.7559 359.958C43.7338 359.756 43.7161 359.565 43.7024 359.385C43.6086 358.151 45.2777 357.704 45.8135 358.819C45.8915 358.982 45.9716 359.156 46.0537 359.342C47.2455 362.051 48.277 364.038 50.1323 364.007C51.9876 363.976 52.0832 360.855 51.951 357.629C51.8188 354.403 51.4504 352.904 52.1135 351.529C52.7765 350.153 54.2359 342.806 49.2879 340.238ZM37.5266 344.903C37.5741 345.272 37.3135 345.611 36.9443 345.66C36.8123 345.679 33.8939 346.125 33.9267 349.433C33.9297 349.748 33.7167 350.016 33.4254 350.094C33.3714 350.108 33.3149 350.116 33.2564 350.117C32.8826 350.12 32.5766 349.82 32.5728 349.447C32.5369 345.822 35.3017 344.507 36.7686 344.318C37.1394 344.27 37.4787 344.532 37.5266 344.903Z",
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_126_525)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 580.5,
    cy: 408.5,
    r: 17.5,
    fill: "#98BCD6"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 581,
    cy: 409,
    r: 25,
    fill: "#98BCD6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M591.335 401.349C589.905 399.11 587.76 398.538 586.053 398.497C584.352 398.456 582.677 398.007 581.184 397.192C579.685 396.374 577.541 395.797 575.183 397.021C570.714 399.34 572.032 405.975 572.631 407.218C573.23 408.46 572.897 409.814 572.778 412.727C572.658 415.641 572.745 418.459 574.42 418.487C576.096 418.515 577.027 416.721 578.104 414.274C578.178 414.106 578.25 413.949 578.321 413.802C578.805 412.795 580.312 413.198 580.227 414.313C580.215 414.475 580.199 414.648 580.179 414.83C579.888 417.488 579.798 419.507 581.263 420.32C582.728 421.134 584.212 418.736 585.565 416.153C586.919 413.571 587.307 412.232 588.447 411.455C589.587 410.679 594.046 405.592 591.335 401.349ZM580.03 399.686C579.9 399.997 579.544 400.144 579.233 400.016C579.121 399.97 576.637 399.002 575.169 401.604C575.029 401.852 574.741 401.965 574.478 401.894C574.43 401.881 574.382 401.862 574.336 401.836C574.042 401.67 573.938 401.297 574.104 401.003C575.712 398.152 578.469 398.372 579.701 398.886C580.013 399.016 580.16 399.374 580.03 399.686Z",
    fill: "white"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_126_525)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 479.5,
    cy: 42.5,
    r: 17.5,
    fill: "#98BCD6"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 480,
    cy: 43,
    r: 25,
    fill: "#98BCD6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M491.838 35.0301C490.255 32.5507 487.879 31.9171 485.989 31.8718C484.106 31.8266 482.251 31.3295 480.598 30.4272C478.938 29.5214 476.565 28.8826 473.953 30.2378C469.005 32.8058 470.465 40.1522 471.128 41.528C471.791 42.9037 471.423 44.4024 471.29 47.6284C471.158 50.8544 471.254 53.975 473.109 54.0062C474.964 54.0375 475.996 52.0509 477.188 49.3417C477.27 49.1554 477.35 48.9815 477.428 48.8188C477.964 47.7032 479.633 48.1504 479.539 49.3845C479.525 49.5643 479.508 49.7551 479.485 49.9574C479.163 52.8995 479.063 55.1357 480.685 56.0363C482.308 56.9369 483.951 54.2822 485.449 51.4223C486.948 48.5623 487.378 47.0803 488.64 46.2204C489.902 45.3605 494.839 39.7279 491.838 35.0301ZM479.321 33.1887C479.177 33.5328 478.782 33.6958 478.438 33.5536C478.314 33.5036 475.563 32.4311 473.938 35.3122C473.783 35.5869 473.465 35.7118 473.173 35.6337C473.119 35.6193 473.066 35.5979 473.016 35.5691C472.69 35.3855 472.575 34.9726 472.759 34.647C474.54 31.49 477.592 31.7338 478.957 32.3032C479.302 32.4472 479.465 32.8436 479.321 33.1887Z",
    fill: "white"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_126_525)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 536.141,
    cy: 196.882,
    r: 12.5,
    transform: "rotate(15 536.141 196.882)",
    fill: "#98BCD6"
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 536.495,
    cy: 197.495,
    r: 20,
    transform: "rotate(15 536.495 197.495)",
    fill: "#98BCD6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M542.427 190.261C540.968 188.932 539.319 188.937 538.087 189.238C536.86 189.538 535.572 189.541 534.343 189.246C533.11 188.95 531.462 188.951 530.008 190.285C527.253 192.814 529.483 197.316 530.153 198.09C530.823 198.865 530.846 199.9 531.325 202.012C531.804 204.124 532.411 206.128 533.618 205.824C534.825 205.52 535.145 204.053 535.443 202.09C535.464 201.955 535.485 201.829 535.507 201.71C535.659 200.894 536.818 200.891 536.973 201.707C536.996 201.826 537.018 201.952 537.039 202.087C537.345 204.049 537.671 205.514 538.879 205.814C540.087 206.113 540.687 204.107 541.157 201.993C541.627 199.879 541.647 198.844 542.313 198.066C542.98 197.289 545.192 192.778 542.427 190.261ZM533.999 191.258C533.966 191.506 533.739 191.68 533.491 191.648C533.403 191.637 531.434 191.424 530.885 193.574C530.833 193.779 530.649 193.916 530.446 193.916C530.409 193.916 530.371 193.911 530.333 193.902C530.09 193.84 529.943 193.592 530.005 193.35C530.606 190.994 532.625 190.618 533.609 190.748C533.857 190.781 534.032 191.009 533.999 191.258Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_126_525",
    x: 72,
    y: 121,
    width: 85,
    height: 85,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5,
    result: "effect1_foregroundBlur_126_525"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_126_525",
    x: 0,
    y: 310,
    width: 85,
    height: 85,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5,
    result: "effect1_foregroundBlur_126_525"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_126_525",
    x: 538,
    y: 366,
    width: 85,
    height: 85,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5,
    result: "effect1_foregroundBlur_126_525"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_126_525",
    x: 437,
    y: 0,
    width: 85,
    height: 85,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5,
    result: "effect1_foregroundBlur_126_525"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_126_525",
    x: 498.638,
    y: 159.379,
    width: 75.0059,
    height: 75.0059,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5,
    result: "effect1_foregroundBlur_126_525"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDish);
export default __webpack_public_path__ + "static/media/dish.7432febd9e64322b605d2a03b46bce8e.svg";
export { ForwardRef as ReactComponent };